import React from 'react';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom';
import { ToastContainer, toast, cssTransition } from 'react-toastify';
import Routes from './routes';
import ErrorBoundary from './error-boundary';
import 'react-toastify/dist/ReactToastify.css';
import reduxStore from './redux/store';
import { setUpEnv } from '@graffer-inc/graffer-ui';
import { MaintenancePage } from "./components/pages/maintenance";
import './assets/css/common.scss';
import "react-credit-cards/es/styles-compiled.css";

(async () => {
  setUpEnv(process.env.REACT_APP_ENVIRONMENT);

  if (process.env.REACT_APP_MAINTENANCE_MODE === "yes") {
    ReactDOM.render(<MaintenancePage />, document.getElementById("root"));
    return;
  }

  const Fade = cssTransition({
    enter: 'fade-in',
    exit: 'fade-out',
  });

  ReactDOM.render(
    <Provider store={reduxStore}>
      <ErrorBoundary>
        <Routes />
        <ToastContainer
          hideProgressBar
          transition={Fade}
          autoClose={5000}
          toastClassName="custom-toast"
          bodyClassName="has-text-weight-bold"
          position={toast.POSITION.TOP_RIGHT}
        />
      </ErrorBoundary>
    </Provider>,
    document.getElementById('root'),
  );
})();
